import type { ReactNode } from 'react'

import type { CurrencyPosition } from '@twisto/utils'

import * as styles from './currency-sign.styles'

type Props = {
  children: ReactNode
  disabled: boolean
  position: CurrencyPosition
}

export const CurrencySign = ({ disabled, children, position }: Props) => (
  <span
    css={(theme) => [
      styles.text(theme, position),
      disabled && styles.disabled(theme),
    ]}
  >
    {children}
  </span>
)
